import moment from 'moment'
import React from 'react'
import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import LegendComponent from '../../../common/legend/Legend'
import { i18n } from '../../index'
import type { MonthlyFeelingMeterData } from './feelingReportTypes'
import css from './Feelings.css'
type Props = {
  data: MonthlyFeelingMeterData
  month: moment.Moment
}
const STROKES = {
  DAILY: '#78a22f',
  YEAR_AVERAGE: '#f7ac01',
  MONTH_AVERAGE: '#464646',
}

const FeelingReportGraph = ({ data, month }: Props) => {
  const { yearAverage, monthAverage, byDay } = data
  const transformedData = byDay.map((item) => ({
    ...item,
    yearAverage,
    monthAverage,
  }))
  return (
    <div className={css.graphContainer}>
      <h4>
        {i18n.t('reporting.label.feelingMeter.monthlyFeelingStatistic')}: {month.format('MMMM YYYY')}
      </h4>
      <ResponsiveContainer width='100%' height={300}>
        <ComposedChart
          margin={{
            top: 30,
            right: 40,
            bottom: 10,
            left: 10,
          }}
          data={transformedData}
          className={css.chart}
        >
          <CartesianGrid />

          <XAxis
            dataKey='date'
            axisLine={{
              stroke: '#ccc',
              strokeWidth: 1,
            }}
            tick={{
              fontSize: 12,
            }}
            interval={0}
            tickSize={0}
            tickMargin={10}
            minTickGap={5}
            tickFormatter={(tick) => moment(tick).format('D')}
          />
          <YAxis
            padding={{
              top: 0,
            }}
            domain={[0, 5]}
            axisLine={{
              stroke: '#ccc',
              strokeWidth: 1,
            }}
            tick={{
              fontSize: 12,
            }}
            tickCount={6}
            tickSize={0}
            tickMargin={10}
          />

          <Tooltip />

          <Legend content={<LegendComponent />} />

          <Line
            dataKey='monthAverage'
            dot={false}
            name={i18n.t('reporting.label.feelingMeter.monthAverage')}
            stroke={STROKES.MONTH_AVERAGE}
            strokeWidth={2}
          />

          <Line
            dataKey='yearAverage'
            dot={false}
            name={i18n.t('reporting.label.feelingMeter.yearAverage')}
            stroke={STROKES.YEAR_AVERAGE}
            strokeWidth={2}
          />

          <Bar
            dataKey='dayAverage'
            name={i18n.t('reporting.feelingsMeter')?.toString()}
            barSize={10}
            fill={STROKES.DAILY}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  )
}

export default FeelingReportGraph
